export enum VerticalAlignment {
  Top = 'top',
  Middle = 'middle',
  Bottom = 'bottom',
}

export enum HorizontalAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export interface AlignmentStyle {
  vertical: VerticalAlignment | null;
  horizontal: HorizontalAlignment | null;
}

export type FontVerticalAlign = 'superscript' | 'subscript';

export interface FontStyle {
  family: string | null;
  size: number | null;
  underline: boolean | null;
  bold: boolean | null;
  italic: boolean | null;
  strikethrough: boolean | null;
  // outline: boolean;
  color: string | null;
}

export enum BorderStyle {
  Solid = 'solid',
  Dotted = 'dotted',
  Dashed = 'dashed',
  Double = 'double',
  Groove = 'groove',
  Ridge = 'ridge',
  Inset = 'inset',
  Outset = 'outset',
  None = 'none',
}

export interface Border {
  borderTop: boolean;
  borderRight: boolean;
  borderBottom: boolean;
  borderLeft: boolean;
  borderStyle: BorderStyle;
  borderColor: string;
  borderWidth: number;
}

export interface FillStyle {
  backgroundColor: string | null;
  patternType: 'solid' | 'gradient' | null;
  gradientColor: string | null;
}

export interface TextAlignment {}

// export interface StyleRequired {
//   font: Font;
//   // border: Partial<Border>;

//   alignment: Alignment;
//   fill: Fill;

//   textWrap: boolean;
//   rotation: number;
// }

export interface StyleTemplate {
  font: Partial<FontStyle>;
  // font: Optional<Font>;
  alignment: Partial<AlignmentStyle>;
  fill: Partial<FillStyle>;

  textWrap: boolean | null;
  rotation: number | null;
}

export type Style = Partial<StyleTemplate>;

export interface Styles {
  [range: string]: Style;
}
export type StylesMatrix = string[][];

export interface SheetStyles {
  styles: Styles;
  stylesMatrix: StylesMatrix;
}
